import { createFileRoute } from '@tanstack/react-router';


export const Route = createFileRoute('/app/listings')({
  // Deep-link contract: ?segment= & ?channel= & ?q= preset the tracker filters,
  // ?part= opens the listing-copy modal for that part, ?analyze=1 auto-opens the
  // Owner/Manager listing-health drawer (the M26 digest email deep link).
  validateSearch: (search) => ({
    segment: typeof search.segment === 'string' ? search.segment : undefined,
    channel: typeof search.channel === 'string' ? search.channel : undefined,
    q: typeof search.q === 'string' ? search.q : undefined,
    part: typeof search.part === 'string' ? search.part : undefined,
    analyze: search.analyze ? 1 : undefined,
  }),
});
